<!--
  导入excel
  lovi 2020-06-11
-->
<template>
  <div class="button-wrap">
    <input
      class="input-file"
      ref="refFile"
      type="file"
      @change="importData"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    />
    <Button type="primary" long @click="importExcel" :loading="importExcelFlag">
      {{ $t("recharge.immediatelyImport") }}
    </Button>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  props: {
    importExcelFlag: {
      type: Boolean,
      default: false
    },
    importExcelModel: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    importExcel() {
      // 点击事件
      document.querySelector(".input-file").click();
    },
    importData(event) {
      if (!event.currentTarget.files.length) {
        return;
      }
      const that = this;
      that.$emit("update:importExcelFlag", true);
      // 拿取文件对象
      var f = event.currentTarget.files[0];
      // 用FileReader来读取
      var reader = new FileReader();
      // 重写FileReader上的readAsBinaryString方法
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var wb; // 读取完成的数据
        var data; // 你需要的数据
        var reader = new FileReader();
        reader.onload = function() {
          // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          // 接下来就是xlsx了，具体可看api
          wb = XLSX.read(binary, {
            type: "binary"
          });
          data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          that.$refs.refFile.value = "";
          let importList = that.dateTransition(data, that.importExcelModel);
          // 自定义方法向父组件传递数据
          that.$emit("getImportData", importList);
        };
        reader.readAsArrayBuffer(f);
      };
      reader.readAsBinaryString(f);
    },
    dateTransition(data, importExcelModel) {
      let importData = [];
      for (let item of data) {
        let obj = {};
        for (let key in item) {
          for (let childItem of importExcelModel) {
            if (key === childItem.label) {
              obj[childItem.value] = item[key];
              break;
            }
          }
        }
        importData.push(obj);
      }
      return importData;
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.button-wrap {
  position: relative;
  .input-file {
    position: absolute;
    width: 100%;
    height: 45px;
    font-size: 20px;
    opacity: 0;
    cursor: pointer;
  }
}
</style>
